import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'

const CompassIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M15.2 8.8l-1.8 4.4-4.4 1.8 1.8-4.4 4.4-1.8z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
)

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <Card>
      <EmptyState
        icon={<CompassIcon />}
        titleAs="h1"
        title="Page not found"
        description="That route does not exist in this application. Search is the front door."
        actions={
          <>
            <Button variant="primary" onClick={() => navigate('/')}>
              Back to search
            </Button>
            <Button variant="ghost" onClick={() => navigate(-1)}>
              Go back
            </Button>
          </>
        }
      />
    </Card>
  )
}
